module.exports = __webpack_public_path__ + "img/shobha-kandel.5333ea1a.jpg";